import * as React from 'react'
import { faClose, FaIcon } from '@/lib/fa'
import { VehicleGroupModel } from '@/app/models/vehicle/vehicleGroupModel'
import EditVehicleGroupDetailsModal from './EditVehicleGroupDetailsModal'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import EditGroupListItem from '@/modules/drivers/modals/groups/edit/EditGroupListItem'
import GroupsLIstNavbar from '@/modules/drivers/modals/groups/components/GroupsLIstNavbar'
import { faUserCheckSolid, faUserDashedRegular, faUsersSolid } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditVehicleGroupModal = ({
  close,
  groups,
  companyId,
}: {
  close: () => void
  groups: VehicleGroupModel[]
  companyId: string
}) => {
  const { t } = useLocalize()
  const [isDetailsOpen, setIsDetailsOpen] = React.useState(false)
  const [selectedGroup, setSelectedGroup] = React.useState<VehicleGroupModel | null>(null)
  const isDefaultGroup = selectedGroup && selectedGroup.id < 0

  const defaultGroups = [
    { id: -1, name: t('vehicleModule.active-vehicles'), icon: faUserCheckSolid },
    { id: -2, name: t('vehicleModule.inactive-vehicles'), icon: faUserDashedRegular },
  ]

  React.useEffect(() => {
    if (selectedGroup) {
      setIsDetailsOpen(true)
    }
  }, [selectedGroup])

  React.useEffect(() => {
    if (selectedGroup && groups) {
      const updatedGroup = groups.find((g) => g.id === selectedGroup.id)
      if (updatedGroup && JSON.stringify(updatedGroup) !== JSON.stringify(selectedGroup)) {
        setSelectedGroup(updatedGroup)
      }
    }
  }, [groups])

  return (
    <ModalLayout>
      <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[500px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
              {t('vehicleModule.edit-groups')}
            </p>
            <p className="tw-text-sm tw-text-content-base/80">
              {t('vehicleModule.select-group-to-edit')}
            </p>
          </div>
          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <div className="tw-overflow-auto tw-pt-0">
          <GroupsLIstNavbar title={t('vehicleModule.default-groups')} />
          <div className="tw-flex tw-flex-col">
            {defaultGroups.map((group) => (
              <EditGroupListItem
                key={group.id}
                group={group as any}
                icon={group.icon}
                setSelectedGroup={setSelectedGroup}
              />
            ))}
          </div>
          <GroupsLIstNavbar title={t('vehicleModule.custom-groups')} />
          <div className="tw-flex tw-flex-col">
            {groups.filter((g) => g.id > 0).map((group) => (
              <EditGroupListItem
                key={group.id}
                group={group as any}
                icon={faUsersSolid}
                setSelectedGroup={setSelectedGroup}
              />
            ))}
          </div>
        </div>
      </div>
      {isDetailsOpen && selectedGroup && (
        <EditVehicleGroupDetailsModal
          companyId={companyId}
          group={selectedGroup}
          isDefaultGroup={!!isDefaultGroup}
          close={() => setIsDetailsOpen(false)}
        />
      )}
    </ModalLayout>
  )
}

export default EditVehicleGroupModal
